import Vue from 'vue';
import ProductQuantity from '@/modules/product/components/ProductQuantity.vue';
export default Vue.extend({
    name: 'ProductUnit',
    components: { ProductQuantity },
    props: {
        units: { type: Array, required: true },
        cartItems: { type: Array, default: () => [] },
        unitQuantities: { type: Object, required: true },
    },
    methods: {
        isNumber(v) { return Number.isFinite(Number(v)); },
        normalizeBool(v) {
            if (typeof v === 'boolean')
                return v;
            if (v === 1)
                return true;
            if (v === 0)
                return false;
            return !!v;
        },
        inCartQty(uuid) {
            const found = this.cartItems?.find((c) => c.selectedUnitUuid === uuid);
            return Number(found?.quantity || 0);
        },
        remaining(u) {
            const stockFlag = this.normalizeBool(u.is_in_stock);
            const avail = Number(u.available_stocks || 0);
            if (!stockFlag)
                return 0;
            return Math.max(0, avail - this.inCartQty(u.uuid));
        },
        clamp(n, lo, hi) {
            n = Number(n || 0);
            return Math.min(hi, Math.max(lo, n));
        },
        update(unitUuid, qty) {
            this.$emit('updateUnitQty', { unitUuid, qty });
        },
    },
});
